export const getPricingContextFromBrowser = (): PricingContextModule.PcxtV3 | undefined => {
  return window.document.pcxtV3 as PricingContextModule.PcxtV3
}
